import { Outlet } from 'react-router';

import { Loader } from '~shared/ui/loader';

import { isSessionValidatedAtom } from '@breezeventures/web-ph-client-auth/model';
import { useAtomValue } from 'jotai';

import { useSessionInit } from '../model';

export const AuthGate = () => {
  const isSessionValidated = useAtomValue(isSessionValidatedAtom);
  useSessionInit();

  if (!isSessionValidated) return <Loader />;

  return <Outlet />;
};
